import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lp2-mini-lesson-tile-coming-soon',
  template: `
    <lp2-mini-lesson-info-banner
      [title]="'lp.unitIndex.comingSoon.title' | translate"
      [body]="'lp.unitIndex.comingSoon.body' | translate"
      iconSrc="/images/icon-coming-soon-lessons.svg"
      iconAlt=""
    ></lp2-mini-lesson-info-banner>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniLessonTileComingSoonComponent {}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lesson-tile-coming-soon/mini-lesson-tile-coming-soon.component.ts